import type { MultiPolygon, Polygon } from 'geojson';
import { SuccessToast } from 'components/success-toast';
import { useWellCounts } from './hooks';
import { wellsSentence } from './utils';

/** How long the toast stays once it can say what changed, as the mock times it. */
const TIMEOUT = 6000;

interface GeometrySavedToastProps {
  areaName: string;
  before: Polygon | MultiPolygon;
  after: Polygon | MultiPolygon;
  onClose: () => void;
}

/**
 * "Area geometry saved", with what the save did to the wells in the boundary.
 * It shows straight away; the wells line joins once both counts land, and the
 * toast holds open until then so it never closes before saying it. If a count
 * fails it reports the save alone and closes as usual.
 *
 * @param {GeometrySavedToastProps} props - The area, the two boundaries and the close.
 * @return {JSX.Element} The toast.
 */
export function GeometrySavedToast({
  areaName,
  before,
  after,
  onClose,
}: GeometrySavedToastProps): JSX.Element {
  const { counts, settled } = useWellCounts(before, after);
  return (
    <SuccessToast
      message="Area geometry saved"
      subtitle={
        counts
          ? `${areaName} updated. ${wellsSentence(counts)}`
          : `${areaName} updated.`
      }
      timeout={settled ? TIMEOUT : 0}
      onClose={() => {
        onClose();
        return true;
      }}
    />
  );
}
